var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDomicilCharger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.09649 1.59719L2.18337 4.64637C1.52998 5.15457 1 6.2363 1 7.05668V12.4363C1 14.1206 2.37213 15.5 4.05644 15.5H12.4635C14.1478 15.5 15.5199 14.1206 15.5199 12.4436V7.15832C15.5199 6.27986 14.9318 5.15457 14.2131 4.65363L9.72646 1.51007C8.71007 0.798598 7.07658 0.834897 6.09649 1.59719Z",
    stroke: "#1D1E21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.90254 9.43832H7.13566V12.0517C7.13566 12.6615 7.49881 12.7849 7.94178 12.3275L10.9627 9.20602C11.3339 8.82491 11.1782 8.50913 10.6155 8.50913H9.38241V5.89578C9.38241 5.28599 9.01926 5.16258 8.57629 5.61992L5.55535 8.74143C5.18821 9.12617 5.34384 9.43832 5.90254 9.43832Z",
    stroke: "#1D1E21",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomicilCharger);
export default __webpack_public_path__ + "static/media/DomicilCharger.77690856ae9e70261b634ae8881e79aa.svg";
export { ForwardRef as ReactComponent };